import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';
import { RemovedInterface } from '../removed/removed-interface';
import { FetchResult } from '@apollo/client/core';

interface RemoveResponse {
  taskHasCarPartRepair: {
    remove: {
      output: RemovedInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskHasCarPartRepairRemoveService {
  constructor(private apollo: Apollo) {}

  remove(
    id: string,
    mutation: DocumentNode
  ): Observable<FetchResult<RemoveResponse>> {
    return this.apollo.mutate<RemoveResponse>({
      mutation: mutation,
      variables: {
        id: id,
      },
    });
  }
}
